import { z } from "zod";
import { DateTypeSchema } from "./core.schema";
import { AgendaItemMotionSchema } from "./agendaItem.schema";
import { BaseFirestoreWStatusTagsSchema } from "./firestore.schema";
import { AgendaSchema, PublicAgendaSchema } from "./agenda.schema";
import { AddressSchema } from "./address.schema";
import { LetterHeadSchema, PublicLetterHeadSchema } from "./letterHead.schema";

// Schemas

export const AttendeeStatusSchema = z.enum(["present", "absent", "phone"]);

export const MeetingTypeOptionTypeSchema = z.enum(["checkbox", "select"]);

export const MeetingOptionTypeSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const MeetingTypeOptionsSchema = z.object({
  optionsLabel: z.string(),
  type: MeetingTypeOptionTypeSchema,
  options: MeetingOptionTypeSchema.array(),
});

export const MeetingTypeTypeSchema = z.object({
  label: z.string(),
  value: z.string(),
  options: MeetingTypeOptionsSchema.optional(),
});

export const AttendeeSchema = z.object({
  userId: z.string(),
  status: AttendeeStatusSchema,
});

export const MeetingMinutesDataSchema = z.object({
  json: z.string(),
  documentId: z.string().optional(),
  latestRevision: z.number().optional(),
});

export const MeetingReviewSchema = z.object({
  itemVersions: z.record(z.number()).optional(),
  startTime: DateTypeSchema.optional(),
  secretary: z.string().optional(),
  chairman: z.string().optional(),
  attendees: AttendeeSchema.array().optional(),
  motions: AgendaItemMotionSchema.array().optional(),
});

export const MeetingSchema = BaseFirestoreWStatusTagsSchema.extend({
  name: z.string(),
  description: z.string(),
  startTime: DateTypeSchema,
  endTime: DateTypeSchema,
  agendaId: z.string(),
  agenda: AgendaSchema.nullable(),
  address: AddressSchema.optional(),
  review: MeetingReviewSchema.optional(),
  minutesData: MeetingMinutesDataSchema.nullish(),
  letterHeadId: z.string().nullish(),
  letterHead: LetterHeadSchema.nullable(),
  teamId: z.string().optional(),
  meetingType: z.string().optional(),
  meetingTypeOption: z.string().or(z.string().array()).optional(),
  agendaUrl: z.string().optional(),
  agendaPdfFileName: z.string().optional(),
  agendaPdfFilePath: z.string().optional(),
  agendaPublishedAt: DateTypeSchema.optional(),
  publishedAt: DateTypeSchema.nullable(),
});

export const MeetingWAgendaPDFSchema = MeetingSchema.required({
  agendaUrl: true,
  agendaPdfFileName: true,
  agendaPdfFilePath: true,
});

export const PublicMeetingSchema = MeetingSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  name: true,
  description: true,
  startTime: true,
  endTime: true,
  agendaId: true,
  agenda: true,
  address: true,
  review: true,
  minutesData: true,
  letterHeadId: true,
  letterHead: true,
  teamId: true,
  meetingType: true,
  meetingTypeOption: true,
  agendaUrl: true,
  agendaPdfFileName: true,
  agendaPdfFilePath: true,
  agendaPublishedAt: true,
  publishedAt: true,
}).extend({
  agenda: PublicAgendaSchema.nullable(),
  letterHead: PublicLetterHeadSchema.nullable(),
});

// DTOs

export const CreateMeetingDtoSchema = MeetingSchema.partial();

export const PutMeetingDtoSchema = CreateMeetingDtoSchema;

export const PatchMeetingDtoSchema = CreateMeetingDtoSchema;
